import { FormField } from '@sunwebgroup/uds-ui/fields/form-field'
import { ToggleButton, ToggleButtonGroup } from '@sunwebgroup/uds-ui/toggle-button'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import * as React from 'react'
import { useIntl } from '@/intl'
import {
  golfEditingValueForSlotSelector,
} from '@/scopes/checkout/components/services/GolfService/selectors'
import {
  getGolfSlotIdBeingEdited,
  useGolfServiceStore,
} from '@/scopes/checkout/components/services/GolfService/store'
import { updateEditingGolfSlotBuggy } from '@/scopes/checkout/domain/actions'
import { useService } from '@/scopes/checkout/domain/hooks'
import { ServiceType } from '@/scopes/checkout/domain/types'
import styles from './Filters.module.css'

const buggyOptions = [
  { value: 'yes', labelId: 'checkout_steps_ancillaries_golf_buggy_yes' },
  { value: 'no', labelId: 'checkout_steps_ancillaries_golf_buggy_no' },
]

export function BuggyFilter() {
  const intl = useIntl()
  const { service, setServiceLocalValue } = useService(ServiceType.Golf)
  const slotId = useGolfServiceStore(getGolfSlotIdBeingEdited)

  const slot = golfEditingValueForSlotSelector(service, slotId ?? '')

  if (!slotId)
    return null

  return (
    <FormField label={intl.formatMessage({ id: 'checkout_steps_ancillaries_golf_buggy_label' })}>
      <ToggleButtonGroup
        type="single"
        className={styles.filterToggleGroup}
        value={slot?.withBuggy ? 'yes' : 'no'}
        onValueChange={(v: string | undefined) => v && setServiceLocalValue(
          updateEditingGolfSlotBuggy({ slotId, withBuggy: v === 'yes' }),
        )}
      >
        {buggyOptions.map((option) => {
          return (
            <ToggleButton
              key={option.value}
              value={option.value}
            >
              <Typography>{intl.formatMessage({ id: option.labelId })}</Typography>
            </ToggleButton>
          )
        })}
      </ToggleButtonGroup>
    </FormField>
  )
}
